import React, { Suspense } from 'react';
import * as Sentry from '@sentry/react';
import { ErrorState } from './ui/ErrorState';
import { LoadingState } from './ui/LoadingState';

export interface RouteWrapperProps {
  children: React.ReactNode;
  fallbackMessage?: string;
  errorTitle?: string;
}

/**
 * Shared route wrapper that implements a consistent data loader pattern via Suspense
 * and localized error handling via Sentry.ErrorBoundary + ErrorState.
 */
export function RouteWrapper({ children, fallbackMessage = 'Loading...', errorTitle = 'Page failed to load' }: RouteWrapperProps) {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <div className="container py-8 max-w-4xl mx-auto">
          <ErrorState 
            title={errorTitle}
            description={error instanceof Error ? error.message : String(error)}
            onRetry={resetError}
          />
        </div>
      )}
    >
      <Suspense fallback={<LoadingState message={fallbackMessage} fullScreen />}>
        {children}
      </Suspense>
    </Sentry.ErrorBoundary>
  );
}
